import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./my-requested-services.actions";
import {map, switchMap} from "rxjs";
import * as fromGraphql from "./my-requested-services.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {PaginationService} from "../../../../services/pagination.service";



@Injectable()
export class MyRequestedServicesEffects {
  getMyRequestedServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getMyRequestedService),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_MY_REQUESTED_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            pageNumber: action?.filtering?.pageNumber,
            itemsPerPage: action?.filtering?.itemsPerPage,
            ...action?.filtering
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching  Services '),
        map(({data}: any) => {
          if (data) {
            const result: any = data?.getMyServiceRequests;
            console.log(result?.response)
            if (result?.response?.status) {
              this.paginationService.setPage({...result?.page, itemsPerPage: action?.filtering?.itemsPerPage});
              console.log(result?.data)
              this.store.dispatch(fromActions.loadMyRequestedServicess({myRequestedServicess: result?.data}))
            } else {
              this.store.dispatch(fromActions.loadMyRequestedServicess({myRequestedServicess: []}))
            }
          }
        })
      );
    })
  ), {dispatch: false});

  constructor(
              private actions$: Actions,
              private apollo: Apollo,
              private store: Store<AppState>,
              private notificationService: NotificationService,
              private paginationService: PaginationService,) {}
}
